// 统一api出口
import home from '~/api/home'
import plugin from '~/api/plugin'
import user from '~/api/user'
import article from '~/api/article'
import homePage from '~/api/homePage'
import pluginTag from '~/api/plugin/plugin-tag'
import swipeItem from '~/api/home/swipeItem'

export default {
  home,
  plugin,
  user,
  article,
  homePage,
  pluginTag,
  swipeItem
}
